<div class="user">
  <div class="user-names">
    <div>
      <p>{{ user().firstName }}</p>
      <p>{{ user().lastName }}</p>
    </div>
  </div>
  @if (userRole() === UserRoleEnum.ADMIN) {
    <a routerLink="/admin"><p class="pill admin-pill">ADMIN</p></a>
  }
  @if (userRole() === UserRoleEnum.CONTENT_MANAGER) {
    <a routerLink="/admin"><p class="pill cm-pill">CONTENT MANAGER</p></a>
  }
</div>
